import { atom } from 'jotai';

export const selectedMemberIdsAtom = atom(new Set<number>());
